/* CY COLLECTION LINKS (2026-10-05) — see snippets/cy-col-links.liquid. A link to a collection that lives as a filter on
   one of the 4 type pages goes to that page, pre-filtered. The href is swapped just before the browser uses it (capture
   phase of click / auxclick / contextmenu / keyboard Enter), so every link on the site is covered without touching its
   markup, and scripts that match menu links by href (mega tabs, menu art) keep seeing the collection URL until then.
   A link that already carries a query or hash is left alone (it was made on purpose). */
(function () {
  'use strict';
  var map = {};
  try { map = JSON.parse(document.getElementById('cy-col-links').textContent) || {}; } catch (e) { return; }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/$/, '');
  function target(a) {
    if (!a || !a.getAttribute) return null;
    var href = a.getAttribute('href'); if (!href) return null;
    var u; try { u = new URL(href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin || u.search || u.hash) return null;
    var p = u.pathname.replace(/\/$/, '');
    if (root && p.indexOf(root + '/collections/') === 0) p = p.slice(root.length);   /* a locale prefix (/en-ca) */
    var to = map[p]; if (!to) return null;
    return root + to;
  }
  function swap(e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]'); var to = target(a);
    if (!to) return;
    var was = a.getAttribute('href');
    a.setAttribute('href', to);
    /* same type page: the browser only changes the hash; cy-collection-tools.js re-filters on hashchange. Put the
       collection URL back once the navigation has read it (a right-click menu keeps the new one until it is used) */
    if (e.type !== 'contextmenu') setTimeout(function () { a.setAttribute('href', was); }, 0);
  }
  ['click', 'auxclick', 'contextmenu'].forEach(function (t) { document.addEventListener(t, swap, true); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter') swap(e); }, true);
})();
